import * as React from "react";
import "./common/styles/App.css";
import { BrowserRouter as Router, Route, Switch, Redirect} from "react-router-dom";

import aiiApp from "./aii";


// nOTES on ROUTER
// there are good docs on integrating react router, and a few things to consider:
// 1) Redux middleware may work for triggering a URL change based on redux state change (Ben has example code)
// 2) Redux docs have tips on router usage
//    https://redux.js.org/advanced/usagewithreactrouter
// 3) Usage of mapStateToProps (in various 'containers') might need an update depending on how route data is used
//    https://reacttraining.com/react-router/web/guides/redux-integration
// 4) There are other libraries out there to do things more magically, but starting with hand-rolled may be best
class App extends React.Component {
    public render() {
        return (
            <Router>
                <Switch>
                    <Route exact path="/" component={aiiApp} />   
                    <Route exact path="/aii/" component={aiiApp} /> 
                    <Route exact path="/DRRIP/AFI/search">    
                        <Redirect to="/aii/" />
                    </Route>
                    <Route exact path="/DRRIP/">    
                        <Redirect to="/aii/" />
                    </Route>
                </Switch>
            </Router>
        );
    }
}

export default App;
